export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10307.6554fbf8.jpg";